import { createContext } from 'react';

import { ReportEvent } from '@hcs/types';

export type ReportEventMessageListener = (e: ReportEvent) => void;
export type ConnectionStatus = 'connected' | 'retrying' | 'disconnected';

export const ReportApiEventsContext = createContext({
  subscribeToReportEvents: (params: {
    callbackId: string;
    componentId: string;
    onMessage: ReportEventMessageListener;
  }) => {
    return;
  },
  unsubscribeFromReportEvents: (params: {
    callbackId: string;
    componentId: string;
  }) => {
    return;
  },
  getConnectionStatus: (): ConnectionStatus => 'disconnected',
});
